import { Box } from '@mui/material';

function ErrorScreen() {
    return <Box>error</Box>;
}

export default ErrorScreen;
